const customerService = {
  title: () => 'Shopping at italist | How to select and pay',
  description: () =>
    'Not sure how to shop at italist? Discover how to access over 200,000 fashion luxury products to choose from, up to 30% cheaper and express shipped'
};

export default customerService;
